export const URL_PREFIXES = {
  BETA_URL_PREFIX: 'carrierlogistics.integ',
  GAMMA_URL_PREFIX: 'carrierlogistics-gamma.aka',
  PROD_URL_PREFIX: 'carrierlogistics.amazon',
  LOCAL_URL_PREFIX: 'localhost',
};
